// Sentry
export const SENTRY_DSN =
	'https://47aa4c33870c4aecc5c32b39b125a159@o4508615315554304.ingest.us.sentry.io/4509005915422720';

// Liine
export const LIINE_BOOKING_WEBHOOK_URL =
	'https://alice.liine.com/api/online_bookings_webhook/4ddd4f20-5070-4286-a58c-4e634d49608d/';

export enum TagTheme {
	AspenDental = 'aspendental',
	AzPetVet = 'azPetVet',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
}

export enum loggingCode {
	ZENOTI_FAILED_TO_FETCH_BOOKING = 'ZENOTI_FAILED_TO_FETCH_BOOKING',
	ZENOTI_FAILED_TO_FETCH_TIMESLOTS = 'ZENOTI_FAILED_TO_FETCH_TIMESLOTS',
	GET_TIMESLOTS_INVALID_PARAMS = 'GET_TIMESLOTS_INVALID_PARAMS',
	ZENOTI_FAILED_TO_FETCH_LOCATIONS = 'ZENOTI_FAILED_TO_FETCH_LOCATIONS',
	ZENOTI_FAILED_TO_FETCH_SERVICES = 'ZENOTI_FAILED_TO_FETCH_SERVICES',
	RESERVE_APPOINTMENT_INVALID_PARAMS = 'RESERVE_APPOINTMENT_INVALID_PARAMS',
	ZENOTI_FAILED_TO_SEARCH_GUESTS = 'ZENOTI_FAILED_TO_SEARCH_GUESTS',
	ZENOTI_FAILED_TO_CREATE_NEW_GUEST = 'ZENOTI_FAILED_TO_CREATE_NEW_GUEST',
	ZENOTI_FAILED_TO_CREATE_GUEST_NOTE = 'ZENOTI_FAILED_TO_CREATE_GUEST_NOTE',
	ZENOTI_FAILED_TO_CREATE_NEW_RESERVATION = 'ZENOTI_FAILED_TO_CREATE_NEW_RESERVATION',
	ZENOTI_FAILED_TO_CONFIRM_RESERVATION = 'ZENOTI_FAILED_TO_CONFIRM_RESERVATION',
	RETURNING_GUEST_FALSE_INFORMATION = 'RETURNING_GUEST_FALSE_INFORMATION',
	GET_SERVICES_INVALID_PARAMS = 'GET_SERVICES_INVALID_PARAMS',
	MAX_BOOKING_ATTEMPTS_EXCEEDED = 'MAX_BOOKING_ATTEMPTS_EXCEEDED',
	CURRENT_BOOKING_ATTEMPT = 'CURRENT_BOOKING_ATTEMPT',
	RESERVE_APPOINTMENT_SUCCESS = 'RESERVE_APPOINTMENT_SUCCESS',
	BOOKING_THANK_YOU_CONFIRMATION = 'BOOKING_THANK_YOU_CONFIRMATION',
}

export enum ErrorLoggingSource {
	ZENOTI = 'ZENOTI',
	USER = 'USER',
	PERSONAL_INFORMATION_STEP = 'Personal Information Step',
}

// Add a few options for Cache Control
// CACHE_CONTROL_NO_CACHE: Used for API get requests that should not be cached
// CACHE_CONTROL_SHORT_TTL: Used for HTML Templates that should be cached for a short period of time
//                          Caching Notes:
//                           - 10 seconds for the browser, 60 seconds for the CDN, and 60 seconds for the CDN to revalidate
//                           - 0 seconds for the CDN to serve stale content if the origin is down
// Refer to: https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/Expiration.html
export const CACHE_CONTROL_NO_CACHE = 'no-cache, max-age=0, must-revalidate';
export const CACHE_CONTROL_SHORT_TTL = 'public, max-age=10, s-maxage=60, stale-while-revalidate=60, stale-if-error=0';

export const MAX_BOOKING_ATTEMPTS = 3;
export const COOKIE_LIFETIME_HOURS = 6;
export const EXPIRY_TIME = COOKIE_LIFETIME_HOURS * 60 * 60 * 1000;
export const USER_SESSION_COOKIE_NAME = 'user_session';

export const VIRTUAL_CENTER_ID = 'bef39bb0-46e9-4db9-876c-ec54718b465d';
export const LEARNING_CENTER_ID = 'd619807d-5bdd-4d3d-8f88-6a088486ac05';
export const HEART_LOCATION_STORAGE_KEY = 'heartedLocation';

// PROD
const PROD_CHAPTER_VIRTUAL_CENTER_ID = 'bef39bb0-46e9-4db9-876c-ec54718b465d';
// STAGE
const STAGE_CHAPTER_VIRTUAL_CENTER_ID = '778b69ea-b1e6-4608-bff3-3dd58d46e351';

// BRAZE
export const BRAZE_SUBSCRIPTION_GROUP_ID = '172e9660-b097-4184-ae77-8d3197051512';
export const BRAZE_INFO_SMS_SUBSCRIPTION_GROUP_ID = '8d7015d7-750a-4a25-8a42-5b196bf0360d';
export const BRAZE_MARKETING_SMS_SUBSCRIPTION_GROUP_ID = '172e9660-b097-4184-ae77-8d3197051512';

export const getChapterVirtualCenterId = (environment: string) => {
	return environment === 'local' || environment === 'stage'
		? STAGE_CHAPTER_VIRTUAL_CENTER_ID
		: PROD_CHAPTER_VIRTUAL_CENTER_ID;
};

// service code before - is if returning guest is true
// service code after - is if returning guest is false
export const promoPageSlugToServiceCode: { [key: string]: string } = {
	'fillers-promo': 'DFOB-DFOB',
	'laser-hair-promo': 'ONLINELHRCONSULTTX-LHRVIRTUALCONSULT',
	'laser-hair-online-consult': 'ONLINELHRCONSULTTX-LHRVIRTUALCONSULT',
	'botox-promo': 'BOB-BOB',
	'hydraglow-promo': 'SFOB-SFOB',
	'facial-promo': 'SFOB-SFOB',
};

export const treatmentCodeToReasonCode: { [key: string]: string } = {
	BOB: '1', // Botox/Xeomin
	DFOB: '2', // Dermal Fillers
	SFOB: '3', // HydraGlow Facial
	SLFOB: '3', // Signature Laser Facial
	ONLINELHRCONSULTTX: '4', // Laser Hair Removal Online Consult
	CSOB: '5', // CoolSculpting
	CSEOB: '6', // Consult / Something Else
	LHRVIRTUALCONSULT: '7', // Laser Hair Removal Virtual Consult
	LHRSTUDIOCONSULT: '8', // Laser Hair Removal Studio Consult
};
